import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { login as apiLogin } from "../services/auth";
import { saveUserChoice } from "../services/storageService";
import { useAuth } from "../context/AuthContext";
import "./LoginPage.css";

export default function LoginPage() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { login } = useAuth();

  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const params = new URLSearchParams(search);
  const sponsor  = params.get("sponsor")  || "admin";
  const platform = params.get("platform") || "";
  const payment  = params.get("payment")  || "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    setError("");

    try {
      const data = await apiLogin(form.email.trim(), form.password);

      // Update global auth context
      login(data.user, data.token || data.accessToken);

      // Persist non-sensitive preferences only
      saveUserChoice({
        email: form.email.trim(),
        sponsor,
        platform,
        payment,
        role: data?.user?.role,
        isAdmin: data?.user?.isAdmin
      });

      const isAdmin = !!data?.user?.isAdmin;

      if (isAdmin) {
        navigate("/dashboard");
      } else {
        let redirect = "/dashboard-entry";
        const qs = [];

        if (sponsor)  qs.push(`sponsor=${encodeURIComponent(sponsor)}`);
        if (platform) qs.push(`platform=${encodeURIComponent(platform)}`);
        if (payment)  qs.push(`payment=${encodeURIComponent(payment)}`);

        if (qs.length) redirect += "?" + qs.join("&");
        navigate(redirect);
      }
    } catch (err) {
      setError(
        err?.response?.data?.error ||
        err?.message ||
        "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };

  const canSubmit = form.email.trim() && form.password;

  return (
    <main className="login-container">
      <h2 className="login-title">Login</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />

        <button disabled={loading || !canSubmit}>
          {loading ? "Logging in…" : "Log In"}
        </button>
      </form>

      {error && <div style={{ color: "red" }}>{error}</div>}
    </main>
  );
}
